module.exports = __webpack_public_path__ + "img/absolut-first-container-logo.0f038e17.jpg";